import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TextGenerate } from './pages/TextGenerate';
import { Video } from './pages/Video';
import { Gallery } from './pages/Gallery';
import { Dashboard } from './pages/Dashboard';
import { Landing } from './pages/Landing';
import { Terms, Privacy, Compliance2257, Contact } from './pages/Legal';
import { ActivateLanding, ResetLanding } from './pages/AuthLanding';
import { getStorageValue } from '@genfun/core/utils';
import { fetchUser, logPageView } from '@genfun/core/api/auth';
import { GoogleOAuthProvider } from '@react-oauth/google';

function MainApp() {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [signedIn, setSignedIn] = useState(false);
  const [page, setPage] = useState('landing');
  const navigate = (next) => { setPage(next); };

  const gid = process.env.REACT_APP_GOOGLE_ID || '';

  useEffect(() => {
    (async () => {
      const t = getStorageValue("igenfuntoken", null, setToken);
      const [u, status] = await fetchUser(t);
      if (status === 401) {
        setToken(null);
        setUser(null);
      }
      setUser(u);
    })();
  }, [signedIn]);

  useEffect(() => {
    const refParam = new URLSearchParams(window.location.search).get('ref');
    if (refParam && !localStorage.getItem('referral_code')) {
      localStorage.setItem('referral_code', refParam);
    }
    if (!user) {
      const ref = refParam || localStorage.getItem('referral_code');
      logPageView(ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let content;
  if (page === 'landing') {
    content = <Landing token={token} user={user} setSignedIn={setSignedIn} onNavigate={navigate} />;
  } else if (page === 'video') {
    content = <Video token={token} user={user} setSignedIn={setSignedIn} onNavigate={navigate} />;
  } else if (page === 'gallery') {
    content = <Gallery token={token} user={user} setSignedIn={setSignedIn} onNavigate={navigate} />;
  } else if (page === 'terms') {
    content = <Terms onNavigate={navigate} />;
  } else if (page === 'privacy') {
    content = <Privacy onNavigate={navigate} />;
  } else if (page === 'compliance') {
    content = <Compliance2257 onNavigate={navigate} />;
  } else if (page === 'contact') {
    content = <Contact onNavigate={navigate} />;
  } else {
    content = <TextGenerate token={token} user={user} setSignedIn={setSignedIn} onNavigate={navigate} />;
  }

  return gid
    ? <GoogleOAuthProvider clientId={gid}>{content}</GoogleOAuthProvider>
    : content;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/refferal/dude" element={<Dashboard />} />
        <Route path="/activate/:token" element={<ActivateLanding />} />
        <Route path="/reset/:token" element={<ResetLanding />} />
        <Route path="*" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
